export const getWalletFilter = state => state.walletReport.filter
